interface Hook {
  mutate: (obj?: { variables: object }) => void
}

export function withEngagingURL<T extends Hook>(hook: T): T {
  const originalMutate = hook.mutate

  function decorated(obj?: { variables: object }) {
    const variables = Object.assign(
      {
        engagingURL: window.location.href
      },
      obj?.variables ?? {}
    )
    return originalMutate({ variables })
  }

  hook.mutate = decorated
  return hook
}
